import React, { Component } from "react";
import shipstationLogo from "../../../../assets/images/shipstation/shipstation-logo-white.png";
import shipstationLightLogo from "../../../../assets/images/shipstation/shipstation-logo-dark.png";
import shipstationWrenchIcon from "../../../../assets/images/shipstation/wrench-icon.png";
import IGetShipstationCarriersDTO from "../../../../models/DTO/IGetShipstationCarriersDTO";
import IGetShipstationPackageTypesForCarrierDTO from "../../../../models/DTO/IGetShipstationPackageTypesForCarrierDTO";
import IGetShipstationServicesForCarrierDTO from "../../../../models/DTO/IGetShipstationServicesForCarrierDTO";
import IOnGetShipstationCarriersDTO from "../../../../models/DTO/IOnGetShipstationCarriersDTO";
import IOnGetShipstationPackageTypesForCarrierDTO from "../../../../models/DTO/IOnGetShipstationPackageTypesForCarrierDTO";
import IOnGetShipstationServicesForCarrierDTO from "../../../../models/DTO/IOnGetShipstationServicesForCarrierDTO";
import IOnRemoveShipstationAPIKeysDTO from "../../../../models/DTO/IOnRemoveShipstationAPIKeysDTO";
import IOnSetShipstationAPIKeysDTO from "../../../../models/DTO/IOnSetShipstationAPIKeysDTO";
import IRemoveShipstationAPIKeysDTO from "../../../../models/DTO/IRemoveShipstationAPIKeysDTO";
import ISetShipstationAPIKeysDTO from "../../../../models/DTO/ISetShipstationAPIKeysDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IShipstationCarrierDTO from "../../../../models/Shipstation/IShipstationCarrierDTO";
import IShipstationPackageTypeDTO from "../../../../models/Shipstation/IShipstationPackageTypeDTO";
import IShipstationServiceTypeDTO from "../../../../models/Shipstation/IShipstationServiceTypeDTO";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import { injectIntl, WrappedComponentProps } from "react-intl";
import * as _ from "lodash-es";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import { Socket } from "socket.io-client";
import IShipstationResetWebhooksDTO from "../../../../models/DTO/IShipstationResetWebhooksDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";

type Props = {
    intl: any;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    loadData: () => void;
    socket: Socket;
    isMainViewLight?: boolean;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    showShipstationHowto: boolean;
    shipstation_apiKey: string;
    shipstation_apiSecret: string;
    shipstation_bulk_carrierCode: string;
    shipstation_bulk_serviceType: string;
    shipstation_bulk_packageType: string;
    shipstationCarriers: IShipstationCarrierDTO[];
    shipstationServiceTypes: IShipstationServiceTypeDTO[];
    shipstationPackageTypes: IShipstationPackageTypeDTO[];
    resetWebhooksActive: boolean;
};

class ShipstationConnect extends Component<Props & WrappedComponentProps, State> {
    readonly state: State = {
        showShipstationHowto: false,
        shipstation_apiKey: "",
        shipstation_apiSecret: "",
        shipstation_bulk_carrierCode: this.props.supplierModel.Supplier_Integration.shipstation_bulk_carrierCode || "",
        shipstation_bulk_serviceType: this.props.supplierModel.Supplier_Integration.shipstation_bulk_serviceType || "",
        shipstation_bulk_packageType: this.props.supplierModel.Supplier_Integration.shipstation_bulk_packageType || "",
        shipstationCarriers: [],
        shipstationServiceTypes: [],
        shipstationPackageTypes: [],
        resetWebhooksActive: false,
    };

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.ShipstationOnSetApiKeys, this.onSetShipstationApiKeys);
        this.props.socket.on(EndpointsEnum.ShipstationOnRemoveApiKeys, this.onRemoveShipstationApiKeys);
        this.props.socket.on(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetServiceTypes);
        this.props.socket.on(EndpointsEnum.ShipstationOnGetCarriers, this.onGetCarriers);
        this.props.socket.on(EndpointsEnum.ShipstationOnGetPackageTypesForCarriers, this.onGetPackageTypes);
        this.props.socket.on(EndpointsEnum.ShipstationOnResetWebhooks, this.onResetWebhooks);

        if (this.props.supplierModel.Supplier_Integration.has_shipstation) {
            this.getCarriers();

            if (this.state.shipstation_bulk_carrierCode) {
                this.getServiceTypes();
            }

            if (this.state.shipstation_bulk_serviceType) {
                this.getPackageTypes();
            }
        }
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnSetApiKeys, this.onSetShipstationApiKeys);
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnRemoveApiKeys, this.onRemoveShipstationApiKeys);
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetServiceTypes);
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetCarriers, this.onGetCarriers);
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetPackageTypesForCarriers, this.onGetPackageTypes);
        this.props.socket.on(EndpointsEnum.ShipstationOnResetWebhooks, this.onResetWebhooks);
    }

    toggleShipstationHowTo = () => {
        this.setState({
            showShipstationHowto: !this.state.showShipstationHowto,
        });
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            if (name === "shipstation_bulk_carrierCode") {
                this.getServiceTypes();
            }

            if (name === "shipstation_bulk_serviceType") {
                this.getPackageTypes();
            }
        });
    };

    integrateShipstation = () => {
        const payload: ISetShipstationAPIKeysDTO = {
            apiKey: this.state.shipstation_apiKey,
            apiSecret: this.state.shipstation_apiSecret,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationSetApiKeys, payload);
    };

    disconnectShipstation = () => {
        const payload: IRemoveShipstationAPIKeysDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationRemoveApiKeys, payload);
    };

    onSetShipstationApiKeys = (data: IOnSetShipstationAPIKeysDTO) => {
        this.setState(
            {
                shipstation_apiKey: "",
                shipstation_apiSecret: "",
            },
            () => {
                this.props.loadData();
            }
        );
    };

    onRemoveShipstationApiKeys = (data: IOnRemoveShipstationAPIKeysDTO) => {
        this.props.loadData();
    };

    getCarriers = () => {
        const payload: IGetShipstationCarriersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetCarriers, payload);
    };

    onGetCarriers = (data: IOnGetShipstationCarriersDTO) => {
        const processedCarriers = data.carriers.map((carrier) => {
            const carrierDetail = carrier;

            if (!carrierDetail.nickname) {
                carrierDetail.nickname = carrierDetail.name;
            }

            return carrierDetail;
        });

        this.setState({
            shipstationCarriers: processedCarriers,
        });
    };

    getServiceTypes = () => {
        const payload: IGetShipstationServicesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: this.state.shipstation_bulk_carrierCode,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetServicesForCarriers, payload);
    };

    onGetServiceTypes = (data: IOnGetShipstationServicesForCarrierDTO) => {
        this.setState({
            shipstationServiceTypes: data.serviceTypes,
        });
    };

    getPackageTypes = () => {
        const payload: IGetShipstationPackageTypesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: this.state.shipstation_bulk_carrierCode,
            shipstation_serviceType: this.state.shipstation_bulk_serviceType,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationGetPackageTypesForCarriers, payload);
    };

    onGetPackageTypes = (data: IOnGetShipstationPackageTypesForCarrierDTO) => {
        this.setState({
            shipstationPackageTypes: data.packageTypes,
        });
    };

    saveBulkDefaults = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                shipstation_bulk_serviceType: this.state.shipstation_bulk_serviceType,
                shipstation_bulk_carrierCode: this.state.shipstation_bulk_carrierCode,
                shipstation_bulk_packageType: this.state.shipstation_bulk_packageType,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    resetWebhooks = () => {
        const payload: IShipstationResetWebhooksDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipstationResetWebhooks, payload);

        this.setState({
            resetWebhooksActive: true,
        });
    };

    onResetWebhooks = () => {
        const notification: INotification = {
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
            message: "successfully_reset_webhooks",
        };

        this.props.notifyFn(null, notification);

        this.setState({
            resetWebhooksActive: false,
        });
    };

    render() {
        const hasShipstation = _.get(this.props.supplierModel, "Supplier_Integration.has_shipstation", false);

        const placeholderMessage = {
            id: "business.api_key",
        };
        // @ts-expect-error
        const apiKeyPlaceholder = this.props.intl.formatMessage(placeholderMessage);

        const secretPlaceholder = {
            id: "business.api_secret",
        };
        // @ts-expect-error
        const apiSecretPlaceholder = this.props.intl.formatMessage(secretPlaceholder);

        let logo = shipstationLogo;

        if (this.props.isMainViewLight) {
            logo = shipstationLightLogo;
        }

        return (
            <div className="ShipstationConnect">
                <OwAccordion
                    leftImage={logo}
                    leftImageAlt={"ShipStation"}
                    leftImageHeight={30}
                    titleClick={true}
                    rightElem={
                        <div className={"ms-auto"}>
                            {hasShipstation ? (
                                <OwBadge title={"connected"} bgColor={"bg-success"} leftIconClass={"fas fa-check"} />
                            ) : (
                                <OwBadge title={"not_connected"} bgColor={"bg-info"} leftIconClass={"fas fa-info-circle"} />
                            )}
                        </div>
                    }>
                    <div className={"w-15r"}>
                        <div className={hasShipstation ? "d-none" : "detail-section"}>
                            <div>
                                <span
                                    className="pointer"
                                    onClick={() => {
                                        this.toggleShipstationHowTo();
                                    }}>
                                    <i className="fas fa-info-circle" /> Where do I find these?
                                </span>
                            </div>
                            <ul className={"text-muted " + (this.state.showShipstationHowto ? "" : "d-none")}>
                                <li>Login to your ShipStation account</li>
                                <li>
                                    Click the &#39;Wrench&#39; icon (
                                    <img src={shipstationWrenchIcon} height="40px" />) in the top right
                                </li>
                                <li>Under account, click on &#39;API Settings&#39;</li>
                            </ul>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm mb-2"
                                    name="shipstation_apiKey"
                                    value={this.state.shipstation_apiKey}
                                    placeholder={apiKeyPlaceholder}
                                    onChange={this.handleChange}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm mb-2"
                                    name="shipstation_apiSecret"
                                    value={this.state.shipstation_apiSecret}
                                    placeholder={apiSecretPlaceholder}
                                    onChange={this.handleChange}
                                />
                                <OwButton minWidth={80} title={"save"} fn={this.integrateShipstation} />
                            </div>
                        </div>

                        <div className={hasShipstation ? "" : "d-none"}>
                            <div>
                                <OwButton
                                    minWidth={225}
                                    className={"btn-danger"}
                                    fn={this.disconnectShipstation}
                                    leftIconClass={"fas fa-unlink"}
                                    title={"disconnect"}
                                />
                            </div>

                            <div className={"mt-4"}>
                                <OwButton
                                    title={"reset_webhooks"}
                                    fn={this.resetWebhooks}
                                    active={this.state.resetWebhooksActive}
                                    disableOnActive={true}
                                />
                            </div>

                            <div className={"mt-4"}>
                                <div>
                                    <OwLabel title={"bulk_default_carrier"} />
                                    <div>
                                        <OwSelectOption
                                            name={"shipstation_bulk_carrierCode"}
                                            titleProp={"nickname"}
                                            valueProp={"code"}
                                            options={this.state.shipstationCarriers}
                                            selectedOption={this.state}
                                            selectedOptionProp={"shipstation_bulk_carrierCode"}
                                            showBlankFirst={true}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                </div>

                                <div className={"mt-4"}>
                                    <OwLabel title={"bulk_default_service"} />
                                    <div>
                                        <OwSelectOption
                                            name={"shipstation_bulk_serviceType"}
                                            titleProp={"name"}
                                            valueProp={"code"}
                                            options={this.state.shipstationServiceTypes}
                                            selectedOption={this.state}
                                            selectedOptionProp={"shipstation_bulk_serviceType"}
                                            showBlankFirst={true}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                </div>

                                <div className={"mt-4"}>
                                    <OwLabel title={"bulk_default_package"} />
                                    <div>
                                        <OwSelectOption
                                            name={"shipstation_bulk_packageType"}
                                            titleProp={"name"}
                                            valueProp={"code"}
                                            options={this.state.shipstationPackageTypes}
                                            selectedOption={this.state}
                                            selectedOptionProp={"shipstation_bulk_packageType"}
                                            showBlankFirst={true}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                </div>

                                <div className={"mt-4"}>
                                    <OwButton title={"save"} fn={this.saveBulkDefaults} />
                                </div>
                            </div>
                        </div>
                    </div>
                </OwAccordion>
            </div>
        );
    }
}

export default injectIntl(ShipstationConnect);
